import { render, staticRenderFns } from "./ActNewOld.vue?vue&type=template&id=508eb77d&scoped=true"
import script from "./ActNewOld.vue?vue&type=script&lang=js"
export * from "./ActNewOld.vue?vue&type=script&lang=js"
import style0 from "./ActNewOld.vue?vue&type=style&index=0&id=508eb77d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508eb77d",
  null
  
)

export default component.exports